import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { CartProvider } from "@/contexts/CartContext";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import ScrollToTop from "@/components/ScrollToTop";
import { ReplaceCartDialog } from "@/components/ReplaceCartDialog";
import HomePage from "@/pages/HomePage";
import ShopPage from "@/pages/ShopPage";
import AboutPage from "@/pages/AboutPage";
import ProductPage from "@/pages/ProductPage";
import CartPage from "@/pages/CartPage";
import CheckoutPage from "@/pages/CheckoutPage";
import AuthPage from "@/pages/AuthPage";
import ProfilePage from "@/pages/ProfilePage";
import OrderDetailPage from "@/pages/OrderDetailPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import PaymentCancelledPage from "@/pages/PaymentCancelledPage";
import PaymentFailedPage from "@/pages/PaymentFailedPage";
import EftInstructionsPage from "@/pages/EftInstructionsPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import UnsubscribePage from "@/pages/UnsubscribePage";
import TermsPage from "@/pages/TermsPage";
import PrivacyPage from "@/pages/PrivacyPage";
import FAQPage from "@/pages/FAQPage";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminComms from "@/pages/admin/AdminComms";
import AdminCategories from "@/pages/admin/AdminCategories";
import AdminMainCategories from "@/pages/admin/AdminMainCategories";
import AdminSuppliers from "@/pages/admin/AdminSuppliers";
import AdminWindows from "@/pages/admin/AdminWindows";
import AdminOrderCycle from "@/pages/admin/AdminOrderCycle";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminEmailTemplates from "@/pages/admin/AdminEmailTemplates";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminCollectionPoints from "@/pages/admin/AdminCollectionPoints";
import AdminPurchaseOrders from "@/pages/admin/AdminPurchaseOrders";
import AdminPacking from "@/pages/admin/AdminPacking";
import AdminReports from "@/pages/admin/AdminReports";
import AdminSalesReports from "@/pages/admin/AdminSalesReports";
import AdminSupplierReports from "@/pages/admin/AdminSupplierReports";
import AdminAbout from "@/pages/admin/AdminAbout";
import AdminAuditLog from "@/pages/admin/AdminAuditLog";

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <ScrollToTop />
          <div className="min-h-screen flex flex-col relative">
            <div className="noise-overlay" />
            <Routes>
              {/* Admin routes */}
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminDashboard />} />
                <Route path="products" element={<AdminProducts />} />
                <Route path="orders" element={<AdminOrders />} />
                <Route path="comms" element={<AdminComms />} />
                <Route path="reports" element={<AdminReports />} />
                <Route path="sales-reports" element={<AdminSalesReports />} />
                <Route path="supplier-reports" element={<AdminSupplierReports />} />
                <Route path="packing" element={<AdminPacking />} />
                <Route path="purchase-orders" element={<AdminPurchaseOrders />} />
                <Route path="categories" element={<AdminCategories />} />
                <Route path="main-categories" element={<AdminMainCategories />} />
                <Route path="suppliers" element={<AdminSuppliers />} />
                <Route path="windows" element={<AdminWindows />} />
                <Route path="order-cycle" element={<AdminOrderCycle />} />
                <Route path="settings" element={<AdminSettings />} />
                <Route path="email-templates" element={<AdminEmailTemplates />} />
                <Route path="users" element={<AdminUsers />} />
                <Route path="collection-points" element={<AdminCollectionPoints />} />
                <Route path="about" element={<AdminAbout />} />
                <Route path="audit-log" element={<AdminAuditLog />} />
              </Route>
              {/* Customer routes */}
              <Route path="*" element={
                <>
                  <Navbar />
                  <main className="flex-1 relative z-10">
                    <Routes>
                      <Route path="/" element={<HomePage />} />
                      <Route path="/shop" element={<ShopPage />} />
                      <Route path="/about" element={<AboutPage />} />
                      <Route path="/product/:id" element={<ProductPage />} />
                      <Route path="/cart" element={<CartPage />} />
                      <Route path="/checkout" element={<CheckoutPage />} />
                      <Route path="/auth" element={<AuthPage />} />
                      <Route path="/reset-password" element={<ResetPasswordPage />} />
                      <Route path="/unsubscribe" element={<UnsubscribePage />} />
                      <Route path="/terms" element={<TermsPage />} />
                      <Route path="/privacy" element={<PrivacyPage />} />
                      <Route path="/faq" element={<FAQPage />} />
                      <Route path="/profile" element={<ProfilePage />} />
                      <Route path="/orders/:id" element={<OrderDetailPage />} />
                      <Route path="/payment-success" element={<PaymentSuccessPage />} />
                      <Route path="/payment-cancelled" element={<PaymentCancelledPage />} />
                      <Route path="/payment-failed" element={<PaymentFailedPage />} />
                      <Route path="/eft/:orderId" element={<EftInstructionsPage />} />
                    </Routes>
                  </main>
                  <Footer />
                  <WhatsAppFloat />
                </>
              } />
            </Routes>
            <Toaster position="bottom-right" />
            <ReplaceCartDialog />
          </div>
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
